import $ from 'jquery';
import React from 'react';

import {Permissions} from 'auth/PermissionConstants';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {ProteinSummary} from 'molbio/proteins/util/ProteinConstants';
import getTestProps from 'test/lib/cypress/getTestProps';
import FileSearchDropdown from 'ui-library/attach-dropdown/FileSearchDropdown';
import FormInput from 'ui-library/bs/FormInput';
import * as keyboard from 'util/Keyboard';
import {ElementKeyboardEvent, InputChangeEvent} from 'util/Types';

type Protein = ProteinSummary & {permissions: Permissions};

interface Props {
  onChooseProtein: (protein: Protein) => void;
}

interface State {
  query: string;
}

// Allows the user to search for and choose proteins from Benchling.
class ProteinSearchInput extends React.Component<Props, State> {
  state: State = {
    query: '',
  };

  private proteinInputRef = React.createRef<FormInput>();
  private fileSearchDropdownRef = React.createRef<FileSearchDropdown>();

  getInputElement(): HTMLInputElement | HTMLTextAreaElement | null | undefined {
    return this.proteinInputRef.current?.inputRef.current;
  }

  componentDidMount(): void {
    // Prevent <Esc> from closing the modal when the search results list is escaped.
    // This handler has to be added using JQuery because the handler we want to stop
    // is on the bootstrap modal.
    const input = this.getInputElement();
    if (input != null) {
      $(input).on('keyup', (e) => {
        if (keyboard.isEscapeKey(e) && this.state.query) {
          e.stopPropagation();
          this.setState({query: ''});
        }
      });
    }
  }

  componentWillUnmount(): void {
    const input = this.getInputElement();
    if (input != null) {
      $(input).off();
    }
  }

  _handleSelectAttachment = (id: string, name: string, url: string, protein: Protein): void => {
    this.props.onChooseProtein(protein);
    this.setState({query: ''});
  };

  render(): JSX.Element {
    return (
      <div>
        <FormInput
          type="text"
          placeholder="Search for an AA sequence on Benchling"
          value={this.state.query}
          onChange={(e: InputChangeEvent) => {
            this.setState({query: e.target.value});
          }}
          onKeyDown={(e: ElementKeyboardEvent) => {
            this.fileSearchDropdownRef.current?.queryKeydownHandler(e);
          }}
          ref={this.proteinInputRef}
          focusOnMount={true}
          {...getTestProps({component: 'ProteinSearchInput', element: 'formInput'})}
        />
        {this.state.query !== '' && (
          <FileSearchDropdown
            ref={this.fileSearchDropdownRef}
            width="100%"
            query={this.state.query}
            fileType={ModelTypeConstants.PROTEIN}
            selectAttachment={this._handleSelectAttachment}
          />
        )}
      </div>
    );
  }
}

export default ProteinSearchInput;
